/* eslint-disable @typescript-eslint/no-explicit-any */
export enum BlockLabel {
  SharedInvoice = <any>"Delt utbetaling",
  PricePerUnit = <any>"Enhetsberegning per omsetning",
  PricePerUnitManYears = <any>"Enhetsberegning per årsverk",
  SingleAmount = <any>"Fast beløp",
  FixedAmount = <any>"Fast beløp per intervall",
  ConflictfundMembershipDiscount = <any>"Konfliktsfond rabatt",
  ConflictfundMembershipFee = <any>"Konfliktsfond premie",
  MinMax = <any>"Min- og maksavgift",
  ProrataDiscount = <any>"Prorata ved innmelding",
  Percentage = <any>"Prosent ggr",
  DiscountByPercentage = <any>"Prosentvis rabatt",
  RegistrationDiscount = <any>"Rabatt ved innmelding",
  EnsureNetPrice = <any>"Sikre totalt nettobeløp",
  DelayedInvoice = <any>"Utsatt fakturering",
  ExistingMembershipExemption = <any>"Fritak ved eksisterende medlemskap",
}

export const getBlockKeys = (): string[] =>
  Object.keys(BlockLabel).filter((_, index) => index % 2 === 0);

export const getBlockLabel = (key: string): string => {
  const index = Object.keys(BlockLabel).indexOf(key);
  return Object.keys(BlockLabel)[index + 1];
};

export const getBlockKey = (blockEnum: BlockLabel): string => {
  return BlockLabel[blockEnum];
};

export const blocksWithoutDuplicates = [
  BlockLabel.MinMax,
  BlockLabel.ConflictfundMembershipDiscount,
  BlockLabel.ConflictfundMembershipFee,
  BlockLabel.ProrataDiscount,
  BlockLabel.RegistrationDiscount,
  BlockLabel.DelayedInvoice,
  BlockLabel.SharedInvoice,
  BlockLabel.EnsureNetPrice,
  BlockLabel.ExistingMembershipExemption,
];

export const illegalBlockCombinationList = [
  [
    BlockLabel.SharedInvoice,
    BlockLabel.DelayedInvoice,
    BlockLabel.EnsureNetPrice,
  ],
];

export const onlyValidInContingentBlocks = [BlockLabel.EnsureNetPrice];
